import { render, staticRenderFns } from "./userWalletDetailBox.vue?vue&type=template&id=63299230"
import script from "./userWalletDetailBox.vue?vue&type=script&lang=js"
export * from "./userWalletDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports